export enum LaunchType {
  LINK = 'link',
  SCHEME = 'scheme',
  /** 通用下载页 */
  STORE = 'store',
}

/**
 * 唤起 App 的状态
 */
export enum LAUNCH_APP_STATUS {
  FAILED = 0,
  SUCCESS = 1,
  UNKNOWN = 2,
}

/**
 * scheme 方式唤起回调返回结果类型
 */
export enum CALLBACK_RESULT {
  DO_NOTING = 1, // 什么都不做
  LAND_PAGE = 2, // 通用下载落地页
  APP_STORE = 3, // 应用商城
}
